"use client";

import { useEffect, useState } from "react";
import '../assets/css/profile.min.css';
import Cookies from "js-cookie";
import { toast, ToastContainer } from "react-toastify";

export default function ProfilePage () {
    const [isEditing, setIsEditing] = useState(false);
    const [profileData, setProfileData] = useState({});
    const [showPassword, setShowPassword] = useState(false);

    const handleInputChange = (e) => {
        setProfileData({
            ...profileData,
            [e.target.name]: e.target.value,
        });
    };
    useEffect(() => {
        const fetchUserName = async () => {
            const userId = Cookies.get("userId");
            if (!userId) return;
            const data = new FormData(); // ✅ Correct way to declare FormData
            data.append("user_id", userId);

            try {
                const response = await fetch("https://leapatinternational.com/admin/api/v1/web_user_info.php", {
                    method: "POST",
                    body: data, // ✅ FormData sent in POST body
                });
                const result = await response.json();
                if (result.status === "success") {
                    setProfileData(result.data);
                } else {
                    console.error("Error:", result.message);
                }
            } catch (error) {
                console.error("Network Error:", error);
            }
        };
        fetchUserName();
    }, []);

    const handleEditToggle = () => {
        if (isEditing) {
            // Cancel editing - restore original data
            setProfileData({ ...profileData });
        }
        setIsEditing(!isEditing);
    };

    const handleSaveChanges = async (e) => {
        e.preventDefault();

        try {
            const userId = Cookies.get("userId");
            if (!userId) {
                toast.error("User not authenticated");
                return;
            }

            const formData = new FormData();
            formData.append("user_id", userId);
            formData.append("username", profileData.username);
            formData.append("mobile_no", profileData.mobile_no);
            formData.append("email", profileData.email);

            // Only send password if it was changed
            if (profileData.password && profileData.password !== "••••••••") {
                formData.append("password", profileData.password);
            }

            const response = await fetch("https://leapatinternational.com/admin/api/v1/web_user_profile.php", {
                method: "POST",
                body: formData
            });

            const result = await response.json();

            if (result.status === "success") {
                setProfileData(prev => ({
                    ...prev,
                    ...result.data
                }));
                setIsEditing(false);
                setShowPassword(false);
                toast.success("Profile updated successfully!");
            } else {
                toast.error(result.message || "Failed to update profile");
            }
        } catch (error) {
            console.error("Update error:", error);
            toast.error("Network error. Please try again.");
        }
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    return (
        <div className="profile-page-wrapper">
            <div className="full-container">
                <div className="profile-container">
                    {/* Profile Header */}
                    <div className="profile-header">
                        <div className="profile-info">
                            <div className="profile-details">
                                <h1 className="profile-title">My Profile</h1>
                            </div>
                        </div>

                    </div>

                    {/* Profile Form */}
                    <div className="profile-content">
                        <form onSubmit={handleSaveChanges} className="profile-form">
                            <div className="form-grid">
                                {/* Username Field */}
                                <div className="input-group mb-0">
                                    <label htmlFor="username" className="field-label">
                                        Username
                                    </label>
                                    {isEditing ? (
                                        <input
                                            type="text"
                                            id="username"
                                            name="username"
                                            className="input-field"
                                            value={profileData.username}
                                            onChange={handleInputChange}
                                            placeholder="Enter your username"
                                            required
                                        />
                                    ) : (
                                        <div className="display-field">
                                            <span className="field-icon">👤</span>
                                            {profileData.username}
                                        </div>
                                    )}
                                </div>

                                {/* Mobile Field */}
                                <div className="input-group mb-0">
                                    <label htmlFor="mobile" className="field-label">
                                        Mobile Number
                                    </label>
                                    {isEditing ? (
                                        <input
                                            type="tel"
                                            id="mobile_no"
                                            name="mobile_no"
                                            className="input-field"
                                            value={profileData.mobile_no}
                                            onChange={handleInputChange}
                                            placeholder="Enter your mobile number"
                                            required
                                        />
                                    ) : (
                                        <div className="display-field">
                                            <span className="field-icon">📱</span>
                                            {profileData.mobile_no}
                                        </div>
                                    )}
                                </div>

                                {/* Email Field */}
                                <div className="input-group mb-0">
                                    <label htmlFor="email" className="field-label">
                                        Email Address
                                    </label>
                                    {isEditing ? (
                                        <input
                                            type="email"
                                            id="email"
                                            name="email"
                                            className="input-field"
                                            value={profileData.email}
                                            onChange={handleInputChange}
                                            placeholder="Enter your email address"
                                            required
                                        />
                                    ) : (
                                        <div className="display-field">
                                            <span className="field-icon">✉️</span>
                                            {profileData.email}
                                        </div>
                                    )}
                                </div>

                                {/* Password Field */}
                                <div className="input-group mb-0">
                                    <label htmlFor="password" className="field-label">
                                        Password
                                    </label>
                                    {isEditing ? (
                                        <div className="password-input-wrapper">
                                            <input
                                                type={showPassword ? "text" : "password"}
                                                id="password"
                                                name="password"
                                                className="input-field password-field"
                                                value={profileData.password}
                                                onChange={handleInputChange}
                                                placeholder="Enter your password"
                                                required
                                            />
                                            <button type="button" className="password-toggle" onClick={togglePasswordVisibility}>
                                                {showPassword ? "👁️" : "🙈"}
                                            </button>
                                        </div>
                                    ) : (
                                        <div className="display-field">
                                            <span className="field-icon">🔒</span>
                                            ••••••••
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Save Button for Mobile */}
                            {isEditing && (
                                <div className="mobile-save-actions">
                                    <button type="submit" className="button button-success full-width">
                                        Save Changes
                                    </button>
                                    <button type="button" onClick={handleEditToggle} className="button button-secondary full-width">
                                        Cancel
                                    </button>
                                </div>
                            )}
                        </form>
                        <div className="profile-footer">
                            <div className="profile-actions">
                                {!isEditing ? (
                                    <button onClick={handleEditToggle} className="button">
                                        Edit Profile
                                    </button>
                                ) : (
                                    <div className="edit-actions">
                                        <button onClick={handleSaveChanges} className="button button-success">
                                            Save
                                        </button>
                                        <button onClick={handleEditToggle} className="button button-secondary">
                                            Cancel
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </div>
    );
}
